// libraries
import React, { useRef, useState, useEffect } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Image from '/react4xp/components/Image'
import RichText from '/react4xp/components/RichText'

// svg
import { AngleDown } from '/react4xp/components/Svg/Ux/Angle'
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

interface ContactFormPartProps {
    bgColor: 'default' | 'beige' | 'green'
    title?: string
    text?: string
    img?: {
		src: string
		alt?: string
	}
    dropdown?: {
        default: string
        options: Array<{
            text: string
            link: string
            isExternal?: boolean
        }>
    }
}

export default function ContactFormPart({
    bgColor,
    title,
    text,
    img,
    dropdown
}: ContactFormPartProps) {

    // dropdown
	const [isDropdownVisible, setIsDropdownVisible] = useState(false)

    // bind a function on click to close the dropdown if clicked outside
	const dropdownRef = useRef(null)

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsDropdownVisible(false)
			}
		}

		document.addEventListener('mousedown', handleClickOutside)

		return () => {
			document.removeEventListener('mousedown', handleClickOutside)
		}
	}, [])

    return (
        <Section
            className='contact-form-part'
            bgColor={clsx(
                bgColor === 'beige' && 'bg-beige-primary-dark',
                bgColor === 'green' && 'bg-green-secondary-dark',
            )}
            textColor='text-dark'
        >
            <div className='grid-container'>
                <div className='grid-row'>

                    <div className='c-md-5'>
                        <div className='contact-form-part__image'>
                            {img?.src && (
                                <Image
                                    src={img.src} // 550x550
                                    alt={img.alt}
                                    className='cover'
                                />
                            )}
                        </div>
                    </div>

                    <div className='c-md-1 contact-form-part__middle'></div>

                    <div className='c-md-6 contact-form-part__right'>

                        {isNonWhitespaceString(title) && (
                            <h2 className='contact-form-part__title title-md'>
                                {title}
                            </h2>
                        )}

                        {isNonWhitespaceString(text) && (
                            <div className='contact-form-part__text'>
                                <RichText content={text} />
                            </div>
                        )}

                        {dropdown?.options?.length ? (
                            <div
                                ref={dropdownRef}
                                className={clsx(
                                    'contact-form-part__dropdown',
                                    isDropdownVisible && 'open',
                                    bgColor === 'beige' && 'contact-form-part__dropdown--beige',
                                    bgColor === 'green' && 'contact-form-part__dropdown--green',
                                    bgColor === 'default' && 'contact-form-part__dropdown--default'
                                )}
                            >

                                <button
                                    className='filter-select'
                                    onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                                >

                                    <span className='text'>
                                        {dropdown.default}
                                    </span>

                                    <span className='icon'>
                                        <AngleDown />
                                    </span>

                                </button>

                                <div className='filter-options'>
                                    {dropdown.options?.map((item, i) => (
                                        <a
                                            key={i}
                                            href={item.link}
                                            target={item.isExternal ? '_blank' : undefined}
                                            className='filter-option'
                                            //onClick={() => setIsDropdownVisible(false)}
                                        >
                                            
                                            <span>
                                                {item.text}
                                            </span>

                                            <UxArrowRight />
                                            
                                        </a>
                                    ))}

                                </div>

                            </div>
                        ) : <></>}

                    </div>

                </div>
            </div>
        </Section>
    )
}